jQuery(document).ready(function($){
  var int = setInterval(function(){
    if($('#insta-feed img').length>0){
      $('#insta-feed img').each(function(){
        let alt = $(this).attr('alt').substring(0, 20)+'... read more on Instagram';
        $(this).attr('alt', alt);
        console.log(alt);
      })
      clearInterval(int);
    }
  }, 100);
})




/* navigation accesibility */
document.addEventListener('click', function (e) {
  const trigger = e.target.closest('.navigation__submenu-trigger');
  if (!trigger) return;

  const menu = document.getElementById(trigger.getAttribute('aria-controls'));
  if (!menu) return;

  const expanded = trigger.getAttribute('aria-expanded') === 'true';

  trigger.setAttribute('aria-expanded', String(!expanded));
  menu.setAttribute('aria-hidden', String(expanded));
  menu.dataset.hidden = String(expanded);

  if (!expanded) {
    const firstFocusable = menu.querySelector('a, button');
    firstFocusable && firstFocusable.focus();
  }
});

document.addEventListener('keydown', function (e) {
  const trigger = e.target.closest('.navigation__submenu-trigger');
  if (!trigger) return;

  const menu = document.getElementById(trigger.getAttribute('aria-controls'));
  if (!menu) return;

  if (e.key === 'Enter' || e.key === ' ') {
    e.preventDefault();

    const expanded = trigger.getAttribute('aria-expanded') === 'true';
    trigger.setAttribute('aria-expanded', String(!expanded));
    menu.setAttribute('aria-hidden', String(expanded));
    menu.dataset.hidden = String(expanded);

    if (!expanded) {
      const firstFocusable = menu.querySelector('a, button');
      firstFocusable && firstFocusable.focus();
    }
  }

  if (e.key === 'Escape') {
    trigger.setAttribute('aria-expanded', 'false');
    menu.setAttribute('aria-hidden', 'true');
    menu.dataset.hidden = 'true';
    trigger.focus();
  }
});
